import 'src/styles/ui/tabs.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

const TAB_PARAM = 'tab';

const Tabs = ({ tabs, children, className }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabIds = tabs.map(tab => tab.id);
  const activeTab = tabIds.includes(searchParams.get(TAB_PARAM))
    ? searchParams.get(TAB_PARAM)
    : tabIds[0];

  const selectTab = tabId => {
    const next = new URLSearchParams(searchParams);
    next.set(TAB_PARAM, tabId);
    setSearchParams(next, { replace: true });
  };

  return (
    <>
      <div className={classNames('tabs', className)} data-testid='page-tabs' role='tablist'>
        {tabs.map(tab => (
          <button
            key={tab.id}
            type='button'
            role='tab'
            aria-selected={activeTab === tab.id}
            className={classNames('tabs__tab', { 'tabs__tab--active': activeTab === tab.id })}
            onClick={() => selectTab(tab.id)}
          >
            {tab.icon && <FontAwesomeIcon icon={tab.icon} className='tabs__icon' />}
            {tab.label}
          </button>
        ))}
      </div>
      {typeof children === 'function' ? children(activeTab) : children}
    </>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.object,
    })
  ).isRequired,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  className: PropTypes.string,
};

Tabs.defaultProps = {
  children: null,
  className: '',
};

export default Tabs;
